import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { VerifyBanner } from "@/components/VerifyBanner";
import { Plus, Heart, Handshake, Repeat, Layers, ArrowRight } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const [counts, setCounts] = useState({ cards: 0, wishlist: 0, matches: 0, received: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/availabilities/mine").catch(() => ({ data: [] })),
      api.get("/wishlist/mine").catch(() => ({ data: [] })),
      user?.email_verified ? api.get("/matches").catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
      user?.email_verified ? api.get("/proposals/received").catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
    ]).then(([c, w, m, r]) => setCounts({ cards: c.data.length, wishlist: w.data.length, matches: m.data.length, received: r.data.filter((p) => p.status === "inviata").length }));
  }, [user]);

  const actions = [
    { to: "/le-mie-carte", icon: Plus, title: "Aggiungi una carta", desc: "Pubblica una carta disponibile allo scambio.", color: "#7C3AED" },
    { to: "/wishlist", icon: Heart, title: "Completa la wishlist", desc: "Indica le carte che stai cercando.", color: "#2DD4BF" },
    { to: "/match", icon: Handshake, title: "Vedi i match", desc: "Scopri le corrispondenze reciproche.", color: "#10B981" },
  ];

  const stats = [
    { label: "Le mie carte", value: counts.cards, to: "/le-mie-carte", icon: Layers },
    { label: "Wishlist", value: counts.wishlist, to: "/wishlist", icon: Heart },
    { label: "Match", value: counts.matches, to: "/match", icon: Handshake },
    { label: "Proposte da gestire", value: counts.received, to: "/proposte", icon: Repeat },
  ];

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-[#F8FAFC]">Ciao, {user?.username} 👋</h1>
      <p className="mt-2 text-[#CBD5E1]">Ecco cosa puoi fare adesso su Omniverse.</p>
      <div className="mt-6"><VerifyBanner /></div>

      <div className="grid gap-4 md:grid-cols-3">
        {actions.map((a) => {
          const Icon = a.icon;
          return (
            <Link key={a.to} to={a.to} data-testid={`action-${a.to.slice(1)}`} className="card-lift group rounded-2xl border border-[#2A3655] bg-[#141B2D] p-6">
              <div className="grid h-11 w-11 place-items-center rounded-xl" style={{ background: `${a.color}22` }}><Icon className="h-5 w-5" style={{ color: a.color }} /></div>
              <h3 className="mt-4 flex items-center justify-between font-display text-lg font-semibold text-[#F8FAFC]">{a.title}<ArrowRight className="h-4 w-4 opacity-0 transition-opacity group-hover:opacity-100" /></h3>
              <p className="mt-1 text-sm text-[#CBD5E1]">{a.desc}</p>
            </Link>
          );
        })}
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <Link key={s.label} to={s.to} className="rounded-xl border border-[#2A3655] bg-[#1C2640] p-4" data-testid={`stat-${s.label}`}>
              <Icon className="h-4 w-4 text-[#2DD4BF]" />
              <p className="mt-2 font-display text-2xl font-bold text-[#F8FAFC]">{s.value}</p>
              <p className="text-xs text-[#94A3B8]">{s.label}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
